import { useStore } from "../../../store";
import CommonSidebar from "../components/CommonSidebar";
import { useEffect, useState } from "react";
import { useTheme } from "../../../components/ui";

export const Sidebar = () => {
  const isSidebarToggle = useStore((state) => state.isSidebarToggle);
  const setSidebarToggle = useStore((state) => state.setSidebarToggle);
  const [hasInit, setHasInit] = useState(false);

  useEffect(() => {
    const isSmallScreen = window.matchMedia("(max-width: 768px)").matches;
    // Close sidebar on small screens, open on larger screens
    setSidebarToggle(isSmallScreen);
    setHasInit(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Prevent initial flash-open on small screens before the effect runs
  const effectiveIsSidebarToggle =
    !hasInit &&
    typeof window !== "undefined" &&
    window.matchMedia("(max-width: 768px)").matches
      ? true
      : isSidebarToggle;

  const { theme } = useTheme();
  const glassClass = theme === "dark" ? "sidebar-glass" : "";

  return (
    <aside
      className={`w-lg h-full sidebar  inset-y-0 z-[--z-navbar]  flex-col shadow-lg  ${!effectiveIsSidebarToggle ? "expand-W" : "shrink-W"} ${glassClass}`}
    >
      <CommonSidebar />
    </aside>
  );
};
